const { HomePageHandler } = require('../handlers/Rail/HomePageHandler'),
    { SearchPageHandler } = require('../handlers/Rail/SearchPageHandler'),
    { PassengerDetailPageHandler } = require('../handlers/Rail/PassengerDetailPageHandler'),
    { PassengerReviewPageHandler } = require('../handlers/Rail/PassengerReviewPageHandler'),
    { PaymentPageHandler } = require('../handlers/Rail/PaymentPageHandler'),
    { OnboardHandler } = require('../handlers/Rail/OnboardHandler');

const railMapping = {
    Home: HomePageHandler,
    Search: SearchPageHandler,
    PassengerDetail: PassengerDetailPageHandler,
    PassengerReview: PassengerReviewPageHandler,
    Payment: PaymentPageHandler,
    Onboard: OnboardHandler
}

module.exports = { railMapping }